import React, {PropTypes} from "react";
import {connect} from "react-redux";
import ExpectedJoinerTable from "./components/ExpectedJoinerTable";
import {hashHistory} from "react-router";
import axios from "axios";
import ModalView from "../../onboarding/components/NewJoinerModal";
import LoadingSpinner from "../../loadingSpinner";


function convert(node) {
  node.oD = node.offerDate;
  node.jD = node.joiningDate;
  node.offerDate = node.offerDate ? new Date(node.offerDate) : null;
  node.joiningDate = node.joiningDate ? new Date(node.joiningDate) : null;
  return node;
}


class ExpectedJoiner extends React.Component {

  constructor() {
    super();
    this.state = {joiners: [], loading: true}
    this.edit = this.edit.bind(this);
    this.refresh = this.refresh.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.viewDetails = this.viewDetails.bind(this);

  }

  viewDetails(id) {
    axios.get(process.env.REQ_URL + "/onBoarding/getJoinerById?q=" + id, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.setState({openDialog: true, joinee: response.data.data})

    }).catch((error)=> {
      console.log(error);
    })

  }

  closeDialog() {
    this.setState({openDialog: false})
  }

  componentDidMount() {
    this.props.changeBanner("OnBoarding - Expected")
    axios.get(process.env.REQ_URL + "/onBoarding/getExpectedJoiners", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      console.log(response.data.data);
      response = response.data.data.map((node)=> {
        return convert(node);
      });
      this.setState({joiners: response, loading: false});
    }).catch((error)=> {

    })
  }

  refresh() {
    axios.get(process.env.REQ_URL + "/onBoarding/getExpectedJoiners", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      console.log(response.data.data);
      response = response.data.data.map((node)=> {
        return convert(node);
      });
      this.setState({joiners: response, loading:false});
    }).catch((error)=> {

    })

  }

  edit(id) {
    axios.get(process.env.REQ_URL + "/onBoarding/getJoinerById?q=" + id, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      response.data.data = convert(response.data.data);
      if (response.data.data.name != null) {
        response.data.data.firstName = response.data.data.name.split(' ')[0];
        response.data.data.lastName = response.data.data.name.split(' ')[1];
      }
      this.setState({initialValues: {initialValues: response.data.data}});
      hashHistory.push("/1/admin/onBoardingEdit/" + id);

    }).catch((error)=> {
      console.log(error);

    })
  }

  render() {
    return (
      <div>

          { this.state.loading ? <LoadingSpinner/> : <ExpectedJoinerTable
          viewDetails={this.viewDetails}
          refresh={this.refresh}
          edit={this.edit}
          data={this.state.joiners}
          constants={this.props.constants}
        /> }
        <ModalView
          open={this.state.openDialog}
          joinee={this.state.joinee}
          close={this.closeDialog}
        />
      </div>
    );
  }

}

ExpectedJoiner.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state
  };

}


export default connect(mapStateToProps)(ExpectedJoiner);




/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/onboarding/ExpectedJoiner.js
 **/